import React from "react";
import { Modal, Box, Grid, Divider } from "@mui/material";
import { CgClose } from "react-icons/cg";

const CustomModal = ({
  open,
  setOpen,
  modalContent,
  width,
  modalTitle,
  transparent,
  height,
  scrollable,
  header,
  divider,
  bgcolor,
  CloseModal,
  closeIsActive,
  modalFooter,
  contentScroll
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: width ? width : "30%",
    height: height ? height : "auto",
    overflowY: scrollable ? "scroll" : "hidden",
    bgcolor: bgcolor ? bgcolor : " #ffffff",
    boxShadow: 24,
    borderRadius: "16px",
    outline: "none",
  };
  const style1 = {
    display: "none",
  };

  const HandleCloseModal = () => {
    if (closeIsActive === true) {
      CloseModal();
    }
    else {
      setOpen(false);
    }
  }
  const scrollableContentStyle = {
    height: contentScroll ? "75vh" : "auto",
    overflowY: contentScroll ? "auto" : "hidden",
    zIndex: 100
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      keepMounted
    >
      <Box sx={open ? style : style1} className={scrollable && "CustomScroll"}>
        <Grid
          container
          item
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          lg={12}
          xs={12}
          md={12}
          className="rounded-top"
        >
          {header !== false && (
            <Grid
              container
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              sx={{ padding: "3%" }}
            >
              <Grid item lg={10} md={10} xs={10} className={"textDarkviolet latobold"} alignItems={"center"}>
                {modalTitle}
              </Grid>
              <Grid
                item
                xs={2}
                lg={2}
                md={2}
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                justifyContent={"flex-end"}
              >
                <CgClose
                  onClick={() => HandleCloseModal()}
                  style={{ cursor: "pointer", color: "#000" }}
                  size={20}
                  color="#000"
                  className="mx-2"
                />
              </Grid>
            </Grid>
          )}
        </Grid>
        {divider !== false ? (
          <Divider
            className="w-100 m-0 p-0"
            style={{ backgroundColor: "#a7aba96e" }}
          />
        ) : (
          ""
        )}
        <Grid className={transparent ? "CustomScroll" : "p-4 CustomScroll"} sx={scrollableContentStyle}>{modalContent}</Grid>
        {modalFooter && (
          <Grid
            container
            className="p-3 modal_box_shadow"
            justifyContent={"flex-end"}
          >
            {modalFooter}
          </Grid>)}

      </Box>
    </Modal>
  );
};

export default CustomModal;
